import * as React from "react";
const SvgIconCaretDown = (props) => /* @__PURE__ */ React.createElement("svg", { height: 16, viewBox: "0 0 16 16", width: 16, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m4 4 3.4 3.4c.3.4.9.4 1.2 0l3.3-3.4 2.1 2.2-5.4 5.6c-.3.3-.9.3-1.2 0l-5.4-5.6z" }));
export default SvgIconCaretDown;
